import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../CloudStorage/CloudStorage";

export default function PublicPreviewEP() {
  const path = "Assets/scss/hireexpert.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const laung = localStorage.getItem("laung");
  const [lan, setlan] = useState(laung ?? "en");
  const navigate = useNavigate();



  return (
    <div className="hire-details col-lg-10 mx-auto">
      <p className="breadcrumbs">
        <a >Hire experts &gt; </a>
        <a >Design & creative &gt;</a>
        <a >UI/UX designer &gt;</a> Profile details
      </p>
      <div className="expertdetail-first">
        <div className="expertdetail-row">
          <div className="expert-left">
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/hireexpert/expert-1.svg`}
              alt=""
            />
            <div>
              <h2 className="manage-head">Nolan Levin</h2>
              <h6>
                UI Designer
                <span>
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/hireexpert/map-icon.svg`}
                    alt=""
                  />
                  Riyadh
                </span>
              </h6>
              <p>
                <i className="fa-solid fa-star"></i> 4.5 (3 jobs)
              </p>
            </div>
          </div>
          <div className="expert-right">
            <button className="btn message-btn">Message</button>
            <button className="btn message-btn">Download CV</button>
            <button
              className="btn active message-btn"
              onClick={() => navigate(`/${lan}/YouExpertHiring`)}
            >
              Hire Expert
            </button>
            <button className="btn menu">
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/hireexpert/menu-icon.svg`}
                alt=""
              />
            </button>
          </div>
        </div>
      </div>
      <div className="expertdetail-second col-md-12">
        <div className="row">
          <div className="col-lg-3 col-md-4 expert-second-left d-flex flex-column" style={{rowGap:'10px'}}>
            <p>About Expert</p>
            <div className="about-expert">
              <h6>language</h6>
              <p style={{ color: '#686868' }}> English - Fluent</p>
              <p style={{ color: '#686868' }}>Arabic - Fluent</p>
            </div>
            <div className="about-expert">
              <h6>Academic info</h6>
              <p>MBA - University of Hunnah</p>
              <p>2020-2023</p>
            </div>
            <div className="about-expert">
              <h6>Employment</h6>
              <p>UX designer</p>
              <p>Google - 2020-2023</p>
            </div>
            <div className="about-expert">
              <h6>Rates</h6>
              <p>$15/hour</p>
              <p>$1200/month</p>
            </div>
          </div>
          <div className="col-lg-9 col-md-8 expert-second-right">
            <h4>UI Designer</h4>
            <p>
              Lorem ipsum dolor sit amet consectetur. Et neque id nunc faucibus
              neque auctor massa tempor turpis. Id ac massa tellus sollicitudin
              vitae. Congue quam sed egestas cras sed non adipiscing. Amet mi
              sed viverra pellentesque fusce vestibulum. Ullamcorper orci nisi
              dolor congue mauris fames. Eu integer lorem ullamcorper euismod
              lobortis vitae felis nunc. Accumsan vulputate sed odio nunc
              vivamus tempus vitae. Imperdiet etiam mi amet nisi nunc
              consectetur malesuada sit. Neque varius pellentesque elit interdum
              iaculis netus venenatis et. Vulputate leo purus amet est lacus
              tortor. Mauris amet libero dolor eget pharetra purus. Diam at
              dolor egestas ac nulla nisi aenean. Tellus ac nam nec malesuada
              morbi. Sed adipiscing volutpat id ut at lobortis.
            </p>
            <div className="expert-sub-sec">
              <div className="expert-heading">
                <h6>Competencies</h6>
              </div>
              <div className="skills">
                <p>Photoshop</p>
                <p>Figma</p>
                <p>Drawing</p>
                <p>Branding</p>
                <p>Website</p>
              </div>
            </div>
            <div className="expert-sub-sec">
              <div className="expert-heading">
                <h6>Work samples</h6>
                <button className="btn">View all</button>
              </div>
              <div className="row exp-row">
                <div className="col-lg-4 col-md-6  expert-img">
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/hireexpert/hireexpert-1.png`}
                    className="w-100"
                    alt=""
                  />
                  <h5>App design for trasp…</h5>
                </div>
                <div className="col-lg-4 col-md-6  expert-img">
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/hireexpert/hireexpert-1.png`}
                    className="w-100"
                    alt=""
                  />
                  <h5>App design for trasp…</h5>
                </div>
                <div className="col-lg-4 col-md-6  expert-img">
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/hireexpert/hireexpert-1.png`}
                    className="w-100"
                    alt=""
                  />
                  <h5>App design for trasp…</h5>
                </div>
              </div>
            </div>
            <div className="expert-sub-sec">
              <div className="expert-heading">
                <h6>OTS services</h6>
                <button className="btn">View all</button>
              </div>
              <div className="row exp-row">
                <div className="col-lg-4 col-md-6  expert-img">
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/hireexpert/hireexpert-1.png`}
                    className="w-100"
                    alt=""
                  />
                  <h5>Branding and print designs</h5>
                  <p>
                    Lorem ipsum dolor sit amet, consectetuer adipiscing elit,
                    sed diam nonummy…
                  </p>
                  <h5>$800</h5>
                </div>
                <div className="col-lg-4 col-md-6  expert-img">
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/hireexpert/hireexpert-1.png`}
                    className="w-100"
                    alt=""
                  />
                  <h5>Branding and print designs</h5>
                  <p>
                    Lorem ipsum dolor sit amet, consectetuer adipiscing elit,
                    sed diam nonummy…
                  </p>
                  <h5>$800</h5>
                </div>
                <div className="col-lg-4 col-md-6  expert-img">
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/hireexpert/hireexpert-1.png`}
                    className="w-100"
                    alt=""
                  />
                  <h5>Branding and print designs</h5>
                  <p>
                    Lorem ipsum dolor sit amet, consectetuer adipiscing elit,
                    sed diam nonummy…
                  </p>
                  <h5>$800</h5>
                </div>
              </div>
            </div>
            <div className="rating-sec">
              <h2>
                Rating and Reviews
                <span>
                  <i className="fa-solid fa-star"></i>4.5
                </span>
              </h2>
              <div className="rating-detail">
                <p>
                  Turpis suspendisse elementum tincidunt ac viverra in
                  scelerisque. Ipsum porta in vulputate fringilla urna.
                  Fermentum etiam sed id iaculis leo. Ultricies tempus sit proin
                  ultrices habitant odio metus
                </p>
                <h5>Kianna Stanton</h5>
              </div>
              <div className="rating-detail">
                <p>
                  Turpis suspendisse elementum tincidunt ac viverra in
                  scelerisque. Ipsum porta in vulputate fringilla urna.
                  Fermentum etiam sed id iaculis leo. Ultricies tempus sit proin
                  ultrices habitant odio metus
                </p>
                <h5>Kianna Stanton</h5>
              </div>
              <div className="rating-detail">
                <p>
                  Turpis suspendisse elementum tincidunt ac viverra in
                  scelerisque. Ipsum porta in vulputate fringilla urna.
                  Fermentum etiam sed id iaculis leo. Ultricies tempus sit proin
                  ultrices habitant odio metus
                </p>
                <h5>Kianna Stanton</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
